var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'band py-lg-5px w-100 z-i-50 z-i-lg-50 tw-bg-white',
    _vm.enablePropertyTypeFilters ? 'lg:tw-bg-[#FFFFFF]' : 'lg:tw-bg-gray-50',
    _vm.hideWrapperBorder ? 'tw-border-b-0' : 'tw-border-b tw-border-white',
  ],attrs:{"id":"properties_filter"}},[_c('div',{class:[
      'px-0',
      _vm.enablePropertyTypeFilters ? '' : 'wrapper',
      _vm.enablePropertyTypeFilters ? 'lg:tw-bg-[#FFFFFF]' : 'lg:tw-bg-gray-50',
    ],attrs:{"id":"filters_panel"}},[(!_vm.enableHousemateGroups)?_c('PropertiesSearchDesktopFiltersV2',_vm._g(_vm._b({attrs:{"title-results-count":_vm.titleResultsCount}},'PropertiesSearchDesktopFiltersV2',_vm.propsForV2,false),_vm.$listeners)):_vm._e(),_vm._v(" "),(_vm.enableHousemateGroups)?_c('PropertiesSearchDesktopFiltersV3',_vm._g(_vm._b({attrs:{"title-results-count":_vm.titleResultsCount}},'PropertiesSearchDesktopFiltersV3',_vm.$props,false),_vm.$listeners)):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }